<template>
	<router-link to="/about" class="single_header_nav_link">About</router-link>
	<section class="page">
		<h1>not found</h1>
		<p>Sorry, the requested page could not be found.</p>
		<router-link to="/">Take me back</router-link>
	</section>
</template>